export default "__VITE_ASSET__BybGGSKM__"